import { PayrollCalendar } from '@/modules/Renewals/renewals.types';
import { baseStoreCreator } from '@/utils/store';

export interface PayrollCalendarsPayload {
  /**
   * Single source of truth for renewal payroll calendars. Seeded from the renewal
   * data and updated in place only on step-3 Submit of the renewal calendar modal.
   * Both the read-only section/card and the final renewal PATCH read from here.
   */
  payrollCalendars: PayrollCalendar[];
}

export const DEFAULT_VALUES: PayrollCalendarsPayload = {
  payrollCalendars: [],
};

export const usePayrollCalendarsStore = baseStoreCreator<PayrollCalendarsPayload>(DEFAULT_VALUES);

export default usePayrollCalendarsStore;
